// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"f61452e1","273":"dd8c0c2e","294":"c71dc843","336":"93c34ce3","386":"6afa4b3b","459":"9c85031c","625":"d3fa247d","670":"06141698","711":"b7717c6a","835":"a2814e61"}[chunkId] + ".chunk.js";
};